import React, { useState, useEffect, useContext } from "react";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { RegxExpression } from "../../../utils/common";
import Cookies from "js-cookie";
import { Context } from "../../../utils/context";
import DatePicker from "react-datepicker";
library.add(fas);

function Steptwo({ user_id, setShowModal }) {
  // const [fieldclick, setFieldclick] = useState(false);
  // const handleFields = () => {
  //   setFieldclick(true);
  // };
  // const { getData, IMG_URL, Select2Data, postData } = useContext(Context);
  // const {
  //   control,
  //   register,
  //   handleSubmit,
  //   getValues,
  //   setError,
  //   clearErrors,
  //   formState: { errors },
  //   reset,
  //   trigger,
  // } = useForm();

  // const onSubmit = async (data) => {
  //   const formData = new FormData();
  //   if (data?.id) {
  //     formData.append("id", data?.id);
  //   }
  //   formData.append("user_id", props?.user_id);
  //   formData.append("name", data?.name);
  //   formData.append("license", data?.license);
  //   formData.append("e_date", data?.e_date);
  //   formData.append("reg_no", data?.reg_no);
  //   formData.append("license_type", data?.license_type);
  //   formData.append("license_name", data?.license_name);
  //   formData.append("add_in_license", data?.add_in_license);

  //   try {
  //     const res = await postData(
  //       "/employee/seller-details/s-cirtification-details",
  //       formData
  //     );
  //     if (res?.success) {
  //       // props.nextStep()
  //     } else {
  //       // Handle the case when res.success is false
  //       console.error("Failed to submit data");
  //     }
  //   } catch (error) {
  //     // Handle any errors that occur during the request
  //     console.error("An error occurred while submitting data:", error);
  //   }
  // };

  // const getEditData = async () => {
  //   const res = await getData(
  //     `/employee/seller-details/s-cirtification-details`
  //   );
  //   if (res?.success) {
  //     reset(res?.data);
  //   }
  // };
  // useEffect(() => {
  //   getEditData();
  // }, [props?.user_id]);

  const { IMG_URL, getData, postData } = useContext(Context);

  const [panPreview, setPanPreview] = useState("");
  const [gstPreview, setGstPreview] = useState("");
  const [passbookPreview, setPassbookPreview] = useState("");
  const [kycPreview, setKycPreview] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const imageFile = watch("pan_image");
  const imageFile1 = watch("gst_image");
  const imageFile2 = watch("kyc_photo");
  const imageFile3 = watch("passbook_photo");

  // Load saved bank details
  const getEditData = async () => {
    if (!user_id) return;

    try {
      const res = await getData(`/employee/seller-details/${user_id}`);
      if (res?.success && res.data?.seller_bank_detail) {
        const bank = res.data.seller_bank_detail;

        reset({
          pan_no: bank.pan_no || "",
          gst_no: bank.gst_no || "",
          acc_no: bank.acc_no || "",
          ifsc_code: bank.ifsc_code || "",
          benificary_name: bank.benificary_name || "",
          bank_city: bank.bank_city || "",
          bank_state: bank.bank_state || "",
          bank_name: bank.bank_name || "",
          bank_branch: bank.bank_branch || "",
        });

        if (bank.pan_image) setPanPreview(IMG_URL + bank.pan_image);
        if (bank.gst_image) setGstPreview(IMG_URL + bank.gst_image);
        if (bank.passbook_photo)
          setPassbookPreview(IMG_URL + bank.passbook_photo);
        if (bank.kyc_photo) setKycPreview(IMG_URL + bank.kyc_photo);
      }
    } catch (err) {
      console.log("No bank details yet");
    }
  };

  useEffect(() => {
    if (user_id) {
      getEditData();
    }
  }, [user_id]);

  // Update previews
  useEffect(() => {
    if (imageFile?.[0]) setPanPreview(URL.createObjectURL(imageFile[0]));
    if (imageFile1?.[0]) setGstPreview(URL.createObjectURL(imageFile1[0]));
    if (imageFile2?.[0]) setKycPreview(URL.createObjectURL(imageFile2[0]));
    if (imageFile3?.[0]) setPassbookPreview(URL.createObjectURL(imageFile3[0]));
  }, [imageFile, imageFile1, imageFile2, imageFile3]);

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("pan_no", data.pan_no || "");
    formData.append("gst_no", data.gst_no || "");
    formData.append("acc_no", data.acc_no || "");
    formData.append("ifsc_code", data.ifsc_code || "");
    formData.append("benificary_name", data.benificary_name || "");
    formData.append("bank_city", data.bank_city || "");
    formData.append("bank_state", data.bank_state || "");
    formData.append("bank_name", data.bank_name || "");
    formData.append("bank_branch", data.bank_branch || "");

    if (data.pan_image?.[0]) formData.append("pan_image", data.pan_image[0]);
    if (data.gst_image?.[0]) formData.append("gst_image", data.gst_image[0]);
    if (data.kyc_photo?.[0]) formData.append("kyc_photo", data.kyc_photo[0]);
    if (data.passbook_photo?.[0])
      formData.append("passbook_photo", data.passbook_photo[0]);

    try {
      const res = await postData(
        "/employee/seller-details/add-three",
        formData,
      );
      if (res?.success) {
        setShowModal({ code: res.code, message: res.message });
        // setNewUserContact(res?.data?.contact_no)
        // props.nextStep()
      } else {
        // Handle the case when res.success is false
        await setShowModal({ code: res.code, message: res.message });
      }
      setTimeout(() => {
        setShowModal(0);
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="personal-details-form userForm">
        <div className="details-form-holder">
          <div className="row">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="">
                {/* PAN Number */}
                <div className="row ">
                  <div className="col-lg-6 col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Label className="required form-field">
                        PAN Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter PAN Number"
                        {...register("pan_no", {
                          required: "PAN number is required",
                          pattern: {
                            value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                            message: "Invalid PAN number",
                          },
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.pan_no,
                          "is-valid": !errors?.pan_no && getValues("pan_no"),
                        })}
                      />
                      {errors.pan_no && (
                        <span className="text-danger">
                          {errors.pan_no.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-9 mb-3">
                    <div className="img_input_holder">
                      <div className="img_form_field">
                        <Form.Label className="required">
                          Pan Image Upload*
                        </Form.Label>
                        <Form.Control
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          {...register("pan_image")}
                        />
                      </div>

                      <div className="img_container mt-2">
                        <Row className="">
                          <div className="col-md-12">
                            <Form.Label>Image Preview</Form.Label>
                            {panPreview ? (
                              <div className="image-preview-container">
                                <img
                                  src={panPreview}
                                  alt="PAN Preview"
                                  className="image-preview"
                                  style={{
                                    width: "100px",
                                    height: "70px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            ) : (
                              <small className="text-muted">
                                No image uploaded
                              </small>
                            )}
                          </div>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* GST Number */}
                <div className="row">
                  <div className="col-lg-6 col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Label className="required form-field">
                        GST Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="GST No"
                        {...register("gst_no", {
                          pattern: {
                            value:
                              /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/,
                            message: "Invalid GST number",
                          },
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.gst_no,
                          "is-valid": !errors?.gst_no && getValues("gst_no"),
                        })}
                      />
                      {errors.gst_no && (
                        <span className="text-danger">
                          {errors.gst_no.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-9 mb-3">
                    <div className="img_input_holder">
                      <div className="img_form_field mb-4">
                        <Form.Label>GST Image Upload</Form.Label>
                        <Form.Control
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          {...register("gst_image")}
                        />
                      </div>

                      <div className="img_container">
                        <Row className="">
                          <div className="col-md-12">
                            <Form.Label>Image Preview</Form.Label>
                            {gstPreview ? (
                              <div className="image-preview-container">
                                <img
                                  src={gstPreview}
                                  alt="GST Preview"
                                  className="image-preview"
                                  style={{
                                    width: "100px",
                                    height: "70px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            ) : (
                              <small className="text-muted">
                                No image uploaded
                              </small>
                            )}
                          </div>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bank Details */}
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Label className="required">
                        Account Number*
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Account Number"
                        {...register("acc_no", {
                          required: "Account number is required",
                          pattern: {
                            value: /^\d{9,18}$/,
                            message: "Invalid Account number",
                          },
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.acc_no,
                          "is-valid": !errors?.acc_no && getValues("acc_no"),
                        })}
                      />
                      {errors.acc_no && (
                        <span className="text-danger">
                          {errors.acc_no.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Label className="required">IFSC Code*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter IFSC Code"
                        {...register("ifsc_code", {
                          required: "IFSC Code is required",
                          pattern: {
                            value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                            message: "Invalid IFSC Code",
                          },
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.ifsc_code,
                          "is-valid":
                            !errors?.ifsc_code && getValues("ifsc_code"),
                        })}
                      />
                      {errors.ifsc_code && (
                        <span className="text-danger">
                          {errors.ifsc_code.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Label className="required">
                        Beneficiary Name*
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Beneficiary Name"
                        {...register("benificary_name", {
                          required: "Required",
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.benificary_name,
                        })}
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Label className="required">Bank City*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Bank City"
                        {...register("bank_city", { required: "Required" })}
                        className={classNames("", {
                          "is-invalid": errors?.bank_city,
                        })}
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Label className="required">Bank State*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Bank State"
                        {...register("bank_state", { required: "Required" })}
                        className={classNames("", {
                          "is-invalid": errors?.bank_state,
                        })}
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Label className="required">Bank Name*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Bank Name"
                        {...register("bank_name", { required: "Required" })}
                        className={classNames("", {
                          "is-invalid": errors?.bank_name,
                        })}
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Label className="required">Bank Branch</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Bank Branch"
                        {...register("bank_branch", { required: "Required" })}
                        className={classNames("", {
                          "is-invalid": errors?.bank_branch,
                        })}
                      />
                    </div>
                  </div>
                </div>

                {/* Passbook & KYC */}
                <div className="row ">
                  <div className="col-lg-6 col-md-9 mb-3">
                    <div className="img_input_holder">
                      <div className="img_form_field mb-3">
                        <Form.Label className="required">
                          Upload Passbook photo*
                        </Form.Label>
                        <Form.Control
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          {...register("passbook_photo")}
                        />
                      </div>
                      <Row className="">
                        <div className="col-md-12">
                          <div className="img_container">
                            <Form.Label>Image Preview</Form.Label>
                            {passbookPreview ? (
                              <div className="image-preview-container">
                                <img
                                  src={passbookPreview}
                                  alt="Passbook"
                                  style={{
                                    width: "120px",
                                    height: "80px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            ) : (
                              <small className="text-muted">No image</small>
                            )}
                          </div>
                        </div>
                      </Row>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-9 mb-3">
                    <div className="img_input_holder">
                      <div className="img_form_field ">
                        <Form.Label className="required">
                          Upload KYC Doc (Aadhaar Card, Driving License,
                          Passport)
                        </Form.Label>
                        <Form.Control
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          {...register("kyc_photo")}
                        />
                      </div>
                      <Row className="">
                        <div className="col-md-12">
                          <div className="img_container mt-3">
                            <Form.Label>Image Preview</Form.Label>
                            {kycPreview ? (
                              <div className="image-preview-container">
                                <img
                                  src={kycPreview}
                                  alt="KYC"
                                  style={{
                                    width: "120px",
                                    height: "80px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            ) : (
                              <small className="text-muted">No image</small>
                            )}
                          </div>
                        </div>
                      </Row>
                    </div>
                  </div>
                </div>
                <hr />
                {/* Buttons */}
                <div className="text-center apply_now_btn ">
                  <div className="registerContinueMain">
                    {/* <Button onClick={prevStep} className="back-btn me-3">
                    Back
                  </Button> */}
                    <Button type="submit" className="walletBtn">
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
            {/* <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="">
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Group controlId="name">
                        <Form.Label className="required">
                          Name of Certification
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Name of Certification"
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          {...register("name", {
                            required: "name is required",
                          })}
                        />
                        {errors?.name && (
                          <span className="text-danger">
                            {errors?.name.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Group controlId="Last_Name">
                        <Form.Label className="required">License</Form.Label>

                        <Form.Control
                          type="text"
                          name="license"
                          placeholder="License"
                          className={classNames("", {
                            "is-invalid": errors?.license,
                          })}
                          {...register("license", {
                            required: "license is required",
                          })}
                        />

                        {errors?.license && (
                          <span className="text-danger">
                            {errors?.license.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                </div>
              </div>

           
              <div className="">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-field">
                      <Form.Group controlId="Last_Name">
                        <Form.Label className="required">
                          License Expiry Date
                        </Form.Label>

                        <Controller
                          control={control}
                          name="e_date"
                          rules={{
                            required: "License expiry date is required",
                          }}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              onChange={(date) => field.onChange(date)}
                              dateFormat="yyyy-MM-dd"
                              placeholderText="License Expiry Date"
                              minDate={new Date()}
                              className={classNames("form-control", {
                                "is-invalid": errors?.e_date,
                              })}
                            />
                          )}
                        />

                        {errors?.e_date && (
                          <span className="text-danger">
                            {errors?.e_date?.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Group controlId="Last_Name">
                        <div className="d-flex justify-content-between">
                          <Form.Label className="required form-field">
                            Enter Registration Number
                          </Form.Label>
                          
                        </div>

                        <div className="get-otp-text">
                          <Form.Control
                            type="text"
                            name="reg_no"
                            placeholder="
Enter Registration Number"
                            className={classNames("", {
                              "is-invalid": errors?.reg_no,
                            })}
                            {...register("reg_no", {
                              required: "reg_no is required",
                            })}
                          />

                          {errors?.reg_no && (
                            <span className="text-danger">
                              {errors?.reg_no?.message}
                            </span>
                          )}
                        </div>
                      </Form.Group>
                    </div>
                  </div>

                  
                  <>
                    <div className="col-md-6">
                      <div className="field-bottom">
                        <Form.Group controlId="Last_Name">
                          <Form.Label className="required form-field">
                            License Type
                          </Form.Label>

                          <div className="get-otp-text">
                            <Form.Control
                              type="text"
                              name="license_type"
                              placeholder="License Type"
                              className={classNames("", {
                                "is-invalid": errors?.license_type,
                              })}
                              {...register("license_type", {
                                required: "license_type is required",
                              })}
                            />

                            {errors?.license_type && (
                              <span className="text-danger">
                                {errors?.license_type?.message}
                              </span>
                            )}
                          </div>
                        </Form.Group>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="field-bottom">
                        <Form.Group controlId="Last_Name">
                          <Form.Label className="required form-field">
                            Name on License*
                          </Form.Label>
                          <div className="get-otp-text">
                            <Form.Control
                              type="text"
                              name="license_name"
                              placeholder="Name on License"
                              className={classNames("", {
                                "is-invalid": errors?.license_name,
                              })}
                              {...register("license_name", {
                                required: "license_name is required",
                              })}
                            />

                            {errors?.license_name && (
                              <span className="text-danger">
                                {errors?.license_name?.message}
                              </span>
                            )}
                          </div>
                        </Form.Group>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="field-bottom">
                        <Form.Group controlId="Last_Name">
                          <Form.Label className="required form-field">
                            Address in License
                          </Form.Label>
                          <div className="get-otp-text">
                            <Form.Control
                              type="text"
                              name="add_in_license"
                              placeholder="Address in License"
                              className={classNames("", {
                                "is-invalid": errors?.add_in_license,
                              })}
                              {...register("add_in_license", {
                                required: "add_in_license is required",
                              })}
                            />

                            {errors?.add_in_license && (
                              <span className="text-danger">
                                {errors?.add_in_license?.message}
                              </span>
                            )}
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </>
                
<hr/>
                  <div className="col-md-12">
                    <div className=" text-center apply_now_btn">
                      

                      <Button
                        type="submit"
                       
                        className="walletBtn"
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Form> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default Steptwo;
